<template>
  <nav class="bottom-navigation">
    <div class="nav-container">
      <div class="nav-items">
        <!-- 首页 -->
        <router-link to="/" class="nav-item" :class="{ active: $route.path === '/' }">
          <div class="nav-icon-wrap">
            <img
              :src="$route.path === '/' ? require('@/assets/images/首页选中.png') : require('@/assets/images/首页未选中.png')"
              alt="首页"
              class="nav-icon-img"
            />
          </div>
          <span class="nav-label">{{ $t('bottomNav.首页') }}</span>
        </router-link>

        <!-- 闪期权 -->
        <router-link to="/flash-options" class="nav-item" :class="{ active: $route.path === '/flash-options' }">
          <div class="nav-icon-wrap">
            <svg class="nav-icon-svg" :class="{ active: $route.path === '/flash-options' }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
          </div>
          <span class="nav-label">{{ $t('bottomNav.闪期权') }}</span>
        </router-link>

        <!-- 算力租赁 -->
        <router-link to="/computing" class="nav-item" :class="{ active: $route.path.startsWith('/computing') }">
          <div class="nav-icon-wrap">
            <img
              :src="$route.path.startsWith('/computing') ? require('@/assets/images/算力申请选中.png') : require('@/assets/images/算力申请未选中.png')"
              alt="算力租赁"
              class="nav-icon-img"
            />
          </div>
          <span class="nav-label">{{ $t('bottomNav.算力申请') }}</span>
        </router-link>

        <!-- 资产 -->
        <router-link to="/assets" class="nav-item" :class="{ active: $route.path === '/assets' }">
          <div class="nav-icon-wrap">
            <img
              :src="$route.path === '/assets' ? require('@/assets/images/资产选中.png') : require('@/assets/images/资产未选中.png')"
              alt="资产"
              class="nav-icon-img"
            />
          </div>
          <span class="nav-label">{{ $t('bottomNav.资产') }}</span>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import { useI18n } from 'vue-i18n'
import domainService from '@/services/domainService.js'

export default {
  name: 'BottomNavigation',
  data() {
    return {
      hasCustomerService: false
    }
  },
  async mounted() {
    // 初始化域名服务
    await domainService.init()
    this.hasCustomerService = domainService.hasCustomerService()
  },
  methods: {
    handleCustomerService() {
      domainService.openCustomerService()
    }
  },
  setup() {
    const { t } = useI18n()
    return { t }
  }
}
</script>

<style scoped>
.bottom-navigation {
  position: fixed;
  bottom: 14px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 24px);
  max-width: 600px;
  z-index: 1000;
  padding: 0;
}

.nav-container {
  background:
    radial-gradient(circle at 10% 0%, rgba(47, 241, 210, 0.16), transparent 45%),
    radial-gradient(circle at 90% 100%, rgba(255, 111, 181, 0.08), transparent 40%),
    linear-gradient(180deg, rgba(12, 27, 48, 0.97), rgba(10, 22, 40, 0.98));
  border: 1px solid rgba(88, 126, 167, 0.34);
  border-radius: 18px;
  padding: 8px 10px calc(8px + env(safe-area-inset-bottom));
  box-shadow: 0 12px 32px rgba(3, 10, 23, 0.48), inset 0 1px 0 rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(14px);
}

.nav-items {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 2px;
}

.nav-item {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  text-decoration: none;
  padding: 8px 2px 7px;
  border-radius: 12px;
  transition: all 0.22s ease;
  background: transparent;
  border: 1px solid transparent;
  min-height: 58px;
  min-width: 0;
  overflow: hidden;
}

.nav-item:hover {
  background: rgba(47, 241, 210, 0.07);
}

.nav-icon-wrap {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 31, 53, 0.8);
  box-shadow: inset 0 0 0 1px rgba(88, 126, 167, 0.28);
}

.nav-item .nav-icon-img {
  width: 21px;
  height: 21px;
  object-fit: contain;
  opacity: 0.98;
  /* Normalize unselected icons to a brighter neutral tone */
  filter: brightness(0) saturate(100%) invert(76%) sepia(7%) saturate(230%) hue-rotate(176deg) brightness(95%) contrast(92%);
}

.nav-icon-svg {
  width: 18px;
  height: 18px;
  color: #8a9bb5;
}

.nav-icon-svg.active {
  color: #2ff1d2;
}

.nav-item .nav-label {
  font-size: 10px;
  font-weight: 600;
  color: #c8d3e3;
  letter-spacing: 0;
  text-align: center;
  line-height: 1.25;
  max-width: 100%;
  word-break: break-word;
  overflow-wrap: break-word;
}

.nav-item.active {
  background: linear-gradient(180deg, rgba(47, 241, 210, 0.18), rgba(47, 241, 210, 0.06));
  border-color: rgba(47, 241, 210, 0.46);
  box-shadow: inset 0 0 0 1px rgba(47, 241, 210, 0.14), 0 0 14px rgba(47, 241, 210, 0.18);
}

.nav-item.active:hover {
  background: linear-gradient(180deg, rgba(47, 241, 210, 0.24), rgba(47, 241, 210, 0.1));
}

.nav-item.active .nav-icon-img {
  opacity: 1;
  filter: brightness(0) saturate(100%) invert(80%) sepia(63%) saturate(564%) hue-rotate(103deg) brightness(101%) contrast(94%);
}

.nav-item.active .nav-label {
  color: #2ff1d2;
}

@media (max-width: 480px) {
  .bottom-navigation {
    bottom: 10px;
    width: calc(100% - 16px);
  }

  .nav-container {
    border-radius: 16px;
    padding: 7px 8px calc(7px + env(safe-area-inset-bottom));
  }

  .nav-items {
    gap: 1px;
  }

  .nav-item {
    min-height: 54px;
    padding: 7px 1px 6px;
  }

  .nav-icon-wrap {
    width: 24px;
    height: 24px;
  }

  .nav-item .nav-icon-img {
    width: 18px;
    height: 18px;
  }

  .nav-item .nav-label {
    font-size: 9px;
  }
}

@media (max-width: 360px) {
  .nav-item .nav-label {
    font-size: 8px;
  }
}

@media (min-width: 769px) {
  .bottom-navigation {
    display: none;
  }
}
</style>
